export const columns = [
    {
        name: 'Name',
        sortable: false,
        cell: row => (`${(row.firstName || "")} ${(row.lastName || "")}`)
    },
    {
        name: 'Phone',
        sortable: false,
        cell: row => row.phone
    },
    {
        name: 'Email',
        sortable: false,
        cell: row => row.email
    },
    {
        name: 'Note',
        sortable: false,
        cell: row => row.note
    },
    {
        name: 'Type',
        sortable: false,
        cell: row => row.appraisalContactType === 0 ? 'Inspection Contact' : 'Get Information from Contact'
    }
]